export class HealthRegisterPostgraduateTitlePrivateLaw {
    name: string;
    type: string;
    dateOfIssue: string;
    idToCompare: string;
}
